import req from "@/assets/js/axios"
import store from './../../store'
import qs from 'qs'
import {Message} from 'element-ui'
import Cryptopt from 'jsencrypt';
import md5 from 'js-md5';
import router from '../../router.js'
import fa from "element-ui/src/locale/lang/fa";
//process.env.VUE_APP_CASTLE_UR;//用户信息
//process.env.VUE_APP_HZW_URL;//常规
class Fn {

  test() {
    console.log('公共方法')
  }

  /**
  *  获取用户信息
   *  Deal 是否不验证登录
   *  fn 返回
  */
  getUserInfo(Deal, fn) {
    return new Promise(resolve => {
      return req.apiAxios('POST', `/host/user/UserController/starrycastle-security/getUserInfo`, {}, Deal).then(res => {
        let info = null;
        if (res.error.err_code === 0) {
          let list = res.obj.list || [];
          info = list[0] || null;
          store.dispatch('setInfo', info);
          sessionStorage.setItem('userId', info.id);
        }
        fn && fn(res);
        resolve(info);
      })
    })
  }
  /**
  *  获取用户信息
   *  Deal 是否不验证登录
   *  fn 返回
  */
  getFrontDesigners(params, Deal) {
    let certype =66;
    let _url = '';
    switch(params.role){
      case 'UserRoleOrdinary':certype = 66;break;
      case 'UserRoleStudent':certype = 1;_url='/student/studentController/getFrontStudents';break;
      case 'UserRoleTeacher':certype = 2;_url='/teacher/teacherController/getFrontTeachers';break;
      case 'UserRoleSchool':certype = 3;_url='/school/schoolController/getFrontSchools';break;
    }
    console.log(_url)
    if(params.role==='UserRoleOrdinary'||!_url)return;//普通用户
    return new Promise(resolve => {
      return req.apiAxios('POST', _url, params, Deal).then(res => {
        if (res.error.err_code === 0) {
          let list = res.obj.list[0] || null;
          store.dispatch("setDesigner", list);
        }
        resolve(res);
      })
    })
  }
  /*退出登录*/
  exitLogin(route) {
    return new Promise(resolve => {
      return req.apiAxios('POST', `/host/user/UserController/exitLogin`).then(res => {
        if (res.error.err_code !== 0) return;
        sessionStorage.clear();
        store.dispatch('setInfo', null);
        store.dispatch('setIsRouterAlive', false);
        if (route.meta && route.meta.requireAuth) {
          location.reload();
        }
        resolve();
      })
    })
  }
  /* 获取店铺信息**/
  getStoreInfo(user_id, isTrue) {
    let params = {
      user_id: user_id
    }
    store.dispatch("setSellerInfo", null);
    return new Promise(resolve => {
      return axios.post(`${baseUrl}/user/UserController/starrycastle-security/getUserInfo`, qs.stringify(params)).then(res => {
        if (res.error.err_code !== 0 || !res.obj.list.length) {
          resolve();
          return;
        }
        let info = res.obj.list[0];
        isTrue && store.dispatch("setSellerInfo", info);
        sessionStorage.setItem('Seller_id', info.id);
        resolve();
      })
    })
  }

  /**
   *  @desc  获取url参数
   *  @param  {String} url为穿过来的链接
   *  @param  {String} id为参数名
   */
  GetParam(url, id) {
    url = url + "";
    var regstr = "/(\\?|\\&)" + id + "=([^\\&]+)/";
    var reg = eval(regstr);
    //eval可以将 regstr字符串转换为 正则表达式
    var result = url.match(reg);
    if (result && result[2]) {
      return result[2];
    }
  }

  /** 日期时间格式转化*/
  formatDate(date, fmt) {
    let o = {
      "M+": date.getMonth() + 1,                 //月份
      "d+": date.getDate(),                    //日
      "H+": date.getHours(),                   //小时
      "m+": date.getMinutes(),                 //分
      "s+": date.getSeconds(),                 //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds()             //毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }


  /**
   * 克隆对象
   * @param obj 要克隆的对象
   */
  clone(obj) {
    return JSON.parse(JSON.stringify(obj))
  };

  /**
   * 用于富文本显示
   * */
  filterHtml(obj) {
    if (obj && typeof obj === 'string') {
      let msg = obj.replace(/<[^>]+>|&[^>]+;/g, "").trim(); //去掉所有的html标签和&nbsp;之类的特殊符合
      msg = msg.replace(/[|]*\n/, ''); //去除行尾空格
      // msg = msg.replace(/&nbsp;/ig, ''); //去掉npsp
      // msg = msg.replace(/&ldquo;/ig, ''); //去掉npsp
      // msg = msg.replace(/&rdquo;/ig, ''); //去掉npsp
      // msg = msg.replace(/&middot;/ig, ''); //去掉npsp
      // msg = msg.replace(/&hellip;/ig, ''); //去掉npsp
      // msg = msg.replace(/&mdash;/ig, ''); //去掉npsp
      // msg = msg.replace(/&gt;/ig, ''); //去掉npsp
      // msg = msg.replace(/&lt;/ig, ''); //去掉npsp
      return msg.trim();
    }
    return obj;
  };

  setCookie(name, value, expires, domain, path, secure) {
    var cookieText = "";
    cookieText += encodeURIComponent(name) + "=" + encodeURIComponent(value);
    if (expires instanceof Date) {
      cookieText += "; expires=" + expires.toGMTString();
    }
    if (path) {
      cookieText += "; path=" + path;
    }
    if (domain) {
      cookieText += "; domain=" + domain;
    }
    if (secure) {
      cookieText += "; secure";
    }
    document.cookie = cookieText;
  }

  getCookie(name) {
    var cookieName = encodeURIComponent(name) + "=",
      cookieStart = document.cookie.indexOf(cookieName),
      cookieValue = "";
    if (cookieStart > -1) {
      var cookieEnd = document.cookie.indexOf(";", cookieStart);
      if (cookieEnd == -1) {
        cookieEnd = document.cookie.length;
      }
      cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
    }
    return cookieValue;
  }

  unsetCookie(name, domain, path, secure) {
    this.set(name, "", Date(0), domain, path, secure);
  }

  /**
   * 计算字符串长度，中文字符占两个，英文字符占一个
   * @param str
   * @returns {number}
   */
  getStringLength(str) {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    return len;
  }
// 上传的图片文件转base64编码
  readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.addEventListener("load", function () {
        let src = reader.result;
        resolve(src)
      }, false);
      reader.onerror = () => {
        const err = new Error('读取图片失败')
        reject(err.message)
      }
      if (file) {
        reader.readAsDataURL(file);
      }
    })
  }

  /** 复制文字到剪切板*/
  copyToClipboard (text) {
    // if(text.indexOf('-') !== -1) {
    //   let arr = text.split('-');
    //   text = arr[0] + arr[1];
    // }
    let textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      let successful = document.execCommand('copy');
      let msg = successful ? '成功复制到剪贴板' : '该浏览器不支持点击复制到剪贴板';
      Message.info(msg);
    } catch (err) {
      Message.error('该浏览器不支持点击复制到剪贴板');
    }

    document.body.removeChild(textArea);
  }
  //非对称加密
  encryptRSA(data){
    //公钥
    const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCuYVkbfLeB7GYxIL3XlNcwom+lZLhRzjTGJmXFxQPNKrf2AyvdnI5PXXDgRKfFleo6/oAIF+qpbcs1Bf4parrhvwBlqKXChtwb2c5bRE5P7IKG6AgWOvUlM3yakOwjBTvOTu6sb+iz3W1Efy/i81jJh+nQlBeQYNV1/cL1FIOtQIDAQAB';
    const encrypt = new Cryptopt();
    encrypt.setPublicKey(publicKey);
    //返回加密数据
    return encrypt.encrypt(data);
  }
  //密码md5加密
  async pswMD5(data){
    let res = await this.getServerTime();
    console.log(this.formatDate(new Date(res),'yyyy-MM-dd HH:mm:ss'))
    console.log(new Date(res).getTime())
    //时间戳
    let timestamp = new Date(res).getTime();
    //密码加密
    let password = md5(data);
    console.log(password)
    //密码加上时间戳加密
    password = md5(timestamp + '' + password);
    return {timestamp,password}
  }

  //获取服务器时间
  getServerTime(){
    return new Promise((resolve,reject)=>{
      var xhr = new XMLHttpRequest();
      if( !xhr ){
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
      }
      xhr.open("GET",process.env.VUE_APP_CASTLE_URL+'/currentTimeMillis',true);
      xhr.onreadystatechange=function(res){
        if( xhr.readyState == 4 && xhr.status == 200 ){
          let res = JSON.parse(xhr.responseText);
          resolve(res.obj.timestamp)
        }
      }
      xhr.send(null);
    })
  }
}
export default new Fn();
